type ContentTableProps = {
  headers: string[];
  rows: string[][];
};

export function ContentTable({ headers, rows }: ContentTableProps) {
  return (
    <div className="my-10 overflow-x-auto rounded-xl border border-primary-100">
      <table className="w-full border-collapse">
        <thead className="bg-primary-50">
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                className="px-4 py-3 text-left align-top font-display text-[13px] font-semibold uppercase tracking-wide text-primary-700"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr
              key={ri}
              className={ri % 2 === 1 ? "bg-primary-50/30" : "bg-background"}
            >
              {row.map((cell, ci) => (
                <td
                  key={ci}
                  className={
                    "border-t border-primary-100 px-4 py-3 align-top font-sans text-[14px] leading-[20px] " +
                    (ci === 0
                      ? "font-semibold text-text-primary"
                      : "font-light text-text-secondary")
                  }
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}